// extracted by mini-css-extract-plugin
export default {"suggestion":"_suggestion_HAcdkb","visible":"_visible_O-WH7D","input-with-options":"_input-with-options_ASERK5","item":"_item_VPC2Cw"};